import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { Customer } from '../../../shared/interfaces/customer';
import { Sale } from '../../../shared/interfaces/sale';

@Component({
    selector: 'app-customer-card',
    standalone: true,
    imports: [CommonModule, MatDividerModule],
    templateUrl: './customer-card.component.html',
    styleUrl: './customer-card.component.scss',
})
export class CustomerCardComponent {
    @Input({ required: true }) public customer!: Customer;

    @Input({ required: true }) public sale!: Sale;

}
